<div class="backdrop" *ngIf="showMessage" (click)="toggle()"></div>

<div
  class="tooltip-container"
  [style.z-index]="showMessage ? 2 : 0"
  style="color: black !important"
>
  <img
    src="assets/images/tooltip.svg"
    #icon
    alt="info"
    style="width: 14px; height: 14px; z-index: -1; cursor:pointer;"
    (click)="toggle()"
  />
  <ng-container>
    <div class="arrow down" #arrow [class.hideMessage]="!showMessage"></div>
    <div
      class="tooltip-message custom-scroll"
      [class.hideMessage]="!showMessage"
      #message
    >
      <ng-content select="[message]"></ng-content>
      <p class="dismiss" style="color: black !important">
        <span *ngIf="dir=='ltr'" (click)="showMessage = false" style="color: black !important; font-size: 12px;">
        Close</span>
        <span *ngIf="dir=='rtl'" (click)="showMessage = false" style="color: black !important; font-size: 12px;">
          إغلاق</span>
      </p>
     
    </div>
  </ng-container>
</div>
